import * as React from "react";

export interface IH3Props {
  className?: string;
}

const H3: React.StatelessComponent<IH3Props> = ({ children, className }) => <h3 className={`h3 ${className}`}>{children}</h3>;

export default H3;
